import { api } from '../api';

export type ContentType = 'MAKE_SENTENCE' | 'ANSWER_SENTENCE' | 'WORD' | 'ORDER_WORD' | 'PHONEME';

export type HistoryContentScores = Partial<Record<ContentType, number>>;

export interface BgtHistoryDay {
  date: string;
  hasData: boolean;
  testCount: number;
  correctCount: number;
  totalUseTime: number;
  avgScore: number | null;
  contentScores: HistoryContentScores;
}

export interface BgtHistorySummary {
  activeDays: number;
  totalTestCount: number;
  totalUseTime: number;
  avgScoreOverall: number | null;
  byContent: HistoryContentScores;
}

export type HistoryCurrentLevels = Partial<Record<ContentType, number>>;

export interface BgtHistoryDetail {
  residentId: string;
  from: string;
  to: string;
  days: BgtHistoryDay[];
  summary: BgtHistorySummary;
  /**
   * 의뢰서 5-2 탭2 — 현재 시점 콘텐츠별 난이도.
   * BGT가 변경 이력을 추적하지 않으므로 변경 시각 표시 불가 (v2에서 본 추적).
   */
  currentLevels: HistoryCurrentLevels;
}

export async function getResidentBgtHistory(
  residentId: string,
  from: string,
  to: string,
): Promise<BgtHistoryDetail> {
  const res = await api.get<BgtHistoryDetail>(`/residents/${residentId}/bgt/history`, {
    params: { from, to },
  });
  return res.data;
}

export const CONTENT_LABELS: Record<ContentType, string> = {
  MAKE_SENTENCE: '문장완성',
  ANSWER_SENTENCE: '문장질문',
  WORD: '단어맞추기',
  ORDER_WORD: '단어순서기억',
  PHONEME: '음소훈련',
};

export const CONTENT_ORDER: ContentType[] = [
  'MAKE_SENTENCE',
  'ANSWER_SENTENCE',
  'WORD',
  'ORDER_WORD',
  'PHONEME',
];
